import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { installSessionGuard } from "./services/sessionGuard";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import VueCookies from 'vue-cookies';
import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
// FontAwesome Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import ISINChart from "@/views/components/custom/Charts/ISINChart.vue";
import GameChart from "@/views/components/custom/Charts/GameChart.vue";

library.add(far);
library.add(fas);
library.add(fab);

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
installSessionGuard();
appInstance.use(ArgonDashboard);
appInstance.use(VueCookies);
appInstance.component("ISINChart", ISINChart);
appInstance.component("GameChart", GameChart);
appInstance.use(VueGoodTablePlugin);
appInstance.use(VueSweetalert2);
appInstance.component('FaIcon', FontAwesomeIcon);
appInstance.mount("#app");
